/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  ProblemDetails,
  ProductRegistrationRequest,
  ProductRegistrationResponse,
} from '../missionImpactAuthAPI.schemas';

import { instance } from '../../mutator-auth';
import type { ErrorType } from '../../mutator-auth';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Idempotent product registration endpoint. Creates a new registration or updates the last sign-in timestamp. Supports both authenticated (JWT-based) and unauthenticated (email-based) registration. For authenticated requests, user is identified from the JWT token. For unauthenticated requests, provide email in the request body.
 * @summary Register product sign-in
 */
export const postProductRegistrations = (
  productId: string,
  productRegistrationRequest: ProductRegistrationRequest,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<ProductRegistrationResponse | ProductRegistrationResponse | void>(
    {
      url: `/v1/products/${productId}/register`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productRegistrationRequest,
      signal,
    },
    options
  );
};

export const getPostProductRegistrationsMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postProductRegistrations>>,
    TError,
    { productId: string; data: ProductRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postProductRegistrations>>,
  TError,
  { productId: string; data: ProductRegistrationRequest },
  TContext
> => {
  const mutationKey = ['postProductRegistrations'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postProductRegistrations>>,
    { productId: string; data: ProductRegistrationRequest }
  > = (props) => {
    const { productId, data } = props ?? {};

    return postProductRegistrations(productId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostProductRegistrationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postProductRegistrations>>
>;
export type PostProductRegistrationsMutationBody = ProductRegistrationRequest;
export type PostProductRegistrationsMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Register product sign-in
 */
export const usePostProductRegistrations = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postProductRegistrations>>,
      TError,
      { productId: string; data: ProductRegistrationRequest },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postProductRegistrations>>,
  TError,
  { productId: string; data: ProductRegistrationRequest },
  TContext
> => {
  const mutationOptions = getPostProductRegistrationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Idempotent product registration endpoint for organizations. Creates a new registration or updates the last sign-in timestamp for an existing one. Requires the authenticated user to have Administrator role in the specified organization.
 * @summary Register product sign-in for organization
 */
export const postOrganizationProductRegistrations = (
  orgId: string,
  productId: string,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<ProductRegistrationResponse | ProductRegistrationResponse>(
    { url: `/v1/orgs/${orgId}/products/${productId}/register`, method: 'POST', signal },
    options
  );
};

export const getPostOrganizationProductRegistrationsMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrganizationProductRegistrations>>,
    TError,
    { orgId: string; productId: string },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrganizationProductRegistrations>>,
  TError,
  { orgId: string; productId: string },
  TContext
> => {
  const mutationKey = ['postOrganizationProductRegistrations'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrganizationProductRegistrations>>,
    { orgId: string; productId: string }
  > = (props) => {
    const { orgId, productId } = props ?? {};

    return postOrganizationProductRegistrations(orgId, productId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrganizationProductRegistrationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrganizationProductRegistrations>>
>;

export type PostOrganizationProductRegistrationsMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Register product sign-in for organization
 */
export const usePostOrganizationProductRegistrations = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrganizationProductRegistrations>>,
      TError,
      { orgId: string; productId: string },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postOrganizationProductRegistrations>>,
  TError,
  { orgId: string; productId: string },
  TContext
> => {
  const mutationOptions = getPostOrganizationProductRegistrationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
